// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Acrom-Light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Acrom-Light.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Acrom-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/Acrom-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/Acrom-Thin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/Acrom-Thin.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/Acrom-Thin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/Acrom-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/Acrom-Bold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../assets/fonts/Acrom-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../assets/fonts/Acrom-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../assets/fonts/Acrom-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../assets/fonts/Acrom-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../assets/fonts/Acrom-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../assets/fonts/Acrom-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../assets/fonts/Acrom-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../assets/fonts/Acrom-ExtraBold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../assets/fonts/Acrom-ExtraBold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../assets/fonts/Acrom-ExtraBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../assets/fonts/Acrom-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../assets/fonts/Acrom-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../assets/fonts/Acrom-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../assets/fonts/Acrom-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../assets/fonts/Acrom-Medium.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */
/* Document
   ========================================================================== */
/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */
html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */
/**
 * Remove the margin in all browsers.
 */
body {
  margin: 0;
}

/**
 * Render the \`main\` element consistently in IE.
 */
main {
  display: block;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */
/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */
hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */
/**
 * Remove the gray background on active links in IE 10.
 */
a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */
abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */
b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */
code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */
small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */
/**
 * Remove the border on images inside links in IE 10.
 */
img {
  border-style: none;
}

/* Forms
   ========================================================================== */
/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */
button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */
button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */
button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */
button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */
button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */
button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */
fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */
legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */
progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */
textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */
[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */
[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */
[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */
::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */
/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */
details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */
summary {
  display: list-item;
}

/* Misc
   ========================================================================== */
/**
 * Add the correct display in IE 10+.
 */
template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */
[hidden] {
  display: none;
}

.container {
  max-width: 1312px;
  margin: 0 auto;
}

@media (max-width: 1440px) {
  .container {
    max-width: 960px;
  }
}
@media (max-width: 1024px) {
  .container {
    max-width: 750px;
  }
}
@media (max-width: 768px) {
  .container {
    max-width: 90%;
  }
}
@media (max-width: 480px) {
  .container {
    max-width: 95%;
  }
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("Acrom Light"), local("Acrom-Light"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: local("Acrom Thin"), local("Acrom-Thin"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
  font-weight: 100;
  font-style: normal;
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: local("Acrom Bold"), local("Acrom-Bold"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: local("Acrom"), local("Acrom-Regular"), url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: local("Acrom ExtraBold"), local("Acrom-ExtraBold"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("truetype");
  font-weight: 800;
  font-style: normal;
}
@font-face {
  font-family: "Acrom";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: local("Acrom Medium"), local("Acrom-Medium"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("truetype");
  font-weight: 500;
  font-style: normal;
}
body {
  font-family: "Acrom", sans-serif;
  background-color: #2B2A29;
}

video {
  object-fit: cover !important;
}`, "",{"version":3,"sources":["webpack://./src/scss/normalize.scss","webpack://./src/scss/stylesheet.scss"],"names":[],"mappings":"AAAA,2EAAA;AAEA;+EAAA;AAGA;;;EAAA;AAKC;EACG,iBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;ACFJ;;ADKE;+EAAA;AAGA;;EAAA;AAIA;EACE,SAAA;ACJJ;;ADOE;;EAAA;AAIA;EACE,cAAA;ACLJ;;ADQE;;;EAAA;AAKA;EACE,cAAA;EACA,gBAAA;ACNJ;;ADSE;+EAAA;AAGA;;;EAAA;AAKA;EACE,uBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;ACRJ;;ADWE;;;EAAA;AAKA;EACE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;ACTJ;;ADYE;+EAAA;AAGA;;EAAA;AAIA;EACE,6BAAA;ACXJ;;ADcE;;;EAAA;AAKA;EACE,mBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,yCAAA;UAAA,iCAAA,EAAA,MAAA;ACZJ;;ADeE;;EAAA;AAIA;;EAEE,mBAAA;ACbJ;;ADgBE;;;EAAA;AAKA;;;EAGE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;ACdJ;;ADiBE;;EAAA;AAIA;EACE,cAAA;ACfJ;;ADkBE;;;EAAA;AAKA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AChBJ;;ADmBE;EACE,eAAA;AChBJ;;ADmBE;EACE,WAAA;AChBJ;;ADmBE;+EAAA;AAGA;;EAAA;AAIA;EACE,kBAAA;AClBJ;;ADqBE;+EAAA;AAGA;;;EAAA;AAKA;;;;;EAKE,oBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;ACpBJ;;ADuBE;;;EAAA;AAKA;QACQ,MAAA;EACN,iBAAA;ACrBJ;;ADwBE;;;EAAA;AAKA;SACS,MAAA;EACP,oBAAA;ACtBJ;;ADyBE;;EAAA;AAIA;;;;EAIE,0BAAA;ACvBJ;;AD0BE;;EAAA;AAIA;;;;EAIE,kBAAA;EACA,UAAA;ACxBJ;;AD2BE;;EAAA;AAIA;;;;EAIE,8BAAA;ACzBJ;;AD4BE;;EAAA;AAIA;EACE,8BAAA;AC1BJ;;AD6BE;;;;;EAAA;AAOA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AC3BJ;;AD8BE;;EAAA;AAIA;EACE,wBAAA;AC5BJ;;AD+BE;;EAAA;AAIA;EACE,cAAA;AC7BJ;;ADgCE;;;EAAA;AAKA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AC9BJ;;ADiCE;;EAAA;AAIA;;EAEE,YAAA;AC/BJ;;ADkCE;;;EAAA;AAKA;EACE,6BAAA,EAAA,MAAA;EACA,oBAAA,EAAA,MAAA;AChCJ;;ADmCE;;EAAA;AAIA;EACE,wBAAA;ACjCJ;;ADoCE;;;EAAA;AAKA;EACE,0BAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;AClCJ;;ADqCE;+EAAA;AAGA;;EAAA;AAIA;EACE,cAAA;ACpCJ;;ADuCE;;EAAA;AAIA;EACE,kBAAA;ACrCJ;;ADwCE;+EAAA;AAGA;;EAAA;AAIA;EACE,aAAA;ACvCJ;;AD0CE;;EAAA;AAIA;EACE,aAAA;ACxCJ;;AAjTA;EACI,iBAAA;EACA,cAAA;AAoTJ;;AAjTA;EACI;IACI,gBAAA;EAoTN;AACF;AAjTA;EACI;IACI,gBAAA;EAmTN;AACF;AAhTA;EACI;IACI,cAAA;EAkTN;AACF;AA/SA;EACI;IACI,cAAA;EAiTN;AACF;AA5SA;EACI,oBAAA;EACA,4CAAA;EACA,iSAAA;EAKA,gBAAA;EACA,kBAAA;AA0SJ;AAvSA;EACI,oBAAA;EACA,4CAAA;EACA,+RAAA;EAKA,gBAAA;EACA,kBAAA;AAqSJ;AAlSA;EACI,oBAAA;EACA,6CAAA;EACA,mSAAA;EAKA,iBAAA;EACA,kBAAA;AAgSJ;AA7RA;EACI,oBAAA;EACA,6CAAA;EACA,iSAAA;EAKA,mBAAA;EACA,kBAAA;AA2RJ;AAxRA;EACI,oBAAA;EACA,6CAAA;EACA,6SAAA;EAKA,gBAAA;EACA,kBAAA;AAsRJ;AAnRA;EACI,oBAAA;EACA,6CAAA;EACA,uSAAA;EAKA,gBAAA;EACA,kBAAA;AAiRJ;AA9QA;EACI,gCAAA;EACA,yBAAA;AAgRJ;;AA7QA;EACI,4BAAA;AAgRJ","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\n html {\n    line-height: 1.15; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n  }\n  \n  /* Sections\n     ========================================================================== */\n  \n  /**\n   * Remove the margin in all browsers.\n   */\n  \n  body {\n    margin: 0;\n  }\n  \n  /**\n   * Render the `main` element consistently in IE.\n   */\n  \n  main {\n    display: block;\n  }\n  \n  /**\n   * Correct the font size and margin on `h1` elements within `section` and\n   * `article` contexts in Chrome, Firefox, and Safari.\n   */\n  \n  h1 {\n    font-size: 2em;\n    margin: 0.67em 0;\n  }\n  \n  /* Grouping content\n     ========================================================================== */\n  \n  /**\n   * 1. Add the correct box sizing in Firefox.\n   * 2. Show the overflow in Edge and IE.\n   */\n  \n  hr {\n    box-sizing: content-box; /* 1 */\n    height: 0; /* 1 */\n    overflow: visible; /* 2 */\n  }\n  \n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  \n  pre {\n    font-family: monospace, monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n  \n  /* Text-level semantics\n     ========================================================================== */\n  \n  /**\n   * Remove the gray background on active links in IE 10.\n   */\n  \n  a {\n    background-color: transparent;\n  }\n  \n  /**\n   * 1. Remove the bottom border in Chrome 57-\n   * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n   */\n  \n  abbr[title] {\n    border-bottom: none; /* 1 */\n    text-decoration: underline; /* 2 */\n    text-decoration: underline dotted; /* 2 */\n  }\n  \n  /**\n   * Add the correct font weight in Chrome, Edge, and Safari.\n   */\n  \n  b,\n  strong {\n    font-weight: bolder;\n  }\n  \n  /**\n   * 1. Correct the inheritance and scaling of font size in all browsers.\n   * 2. Correct the odd `em` font sizing in all browsers.\n   */\n  \n  code,\n  kbd,\n  samp {\n    font-family: monospace, monospace; /* 1 */\n    font-size: 1em; /* 2 */\n  }\n  \n  /**\n   * Add the correct font size in all browsers.\n   */\n  \n  small {\n    font-size: 80%;\n  }\n  \n  /**\n   * Prevent `sub` and `sup` elements from affecting the line height in\n   * all browsers.\n   */\n  \n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n  \n  sub {\n    bottom: -0.25em;\n  }\n  \n  sup {\n    top: -0.5em;\n  }\n  \n  /* Embedded content\n     ========================================================================== */\n  \n  /**\n   * Remove the border on images inside links in IE 10.\n   */\n  \n  img {\n    border-style: none;\n  }\n  \n  /* Forms\n     ========================================================================== */\n  \n  /**\n   * 1. Change the font styles in all browsers.\n   * 2. Remove the margin in Firefox and Safari.\n   */\n  \n  button,\n  input,\n  optgroup,\n  select,\n  textarea {\n    font-family: inherit; /* 1 */\n    font-size: 100%; /* 1 */\n    line-height: 1.15; /* 1 */\n    margin: 0; /* 2 */\n  }\n  \n  /**\n   * Show the overflow in IE.\n   * 1. Show the overflow in Edge.\n   */\n  \n  button,\n  input { /* 1 */\n    overflow: visible;\n  }\n  \n  /**\n   * Remove the inheritance of text transform in Edge, Firefox, and IE.\n   * 1. Remove the inheritance of text transform in Firefox.\n   */\n  \n  button,\n  select { /* 1 */\n    text-transform: none;\n  }\n  \n  /**\n   * Correct the inability to style clickable types in iOS and Safari.\n   */\n  \n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    -webkit-appearance: button;\n  }\n  \n  /**\n   * Remove the inner border and padding in Firefox.\n   */\n  \n  button::-moz-focus-inner,\n  [type=\"button\"]::-moz-focus-inner,\n  [type=\"reset\"]::-moz-focus-inner,\n  [type=\"submit\"]::-moz-focus-inner {\n    border-style: none;\n    padding: 0;\n  }\n  \n  /**\n   * Restore the focus styles unset by the previous rule.\n   */\n  \n  button:-moz-focusring,\n  [type=\"button\"]:-moz-focusring,\n  [type=\"reset\"]:-moz-focusring,\n  [type=\"submit\"]:-moz-focusring {\n    outline: 1px dotted ButtonText;\n  }\n  \n  /**\n   * Correct the padding in Firefox.\n   */\n  \n  fieldset {\n    padding: 0.35em 0.75em 0.625em;\n  }\n  \n  /**\n   * 1. Correct the text wrapping in Edge and IE.\n   * 2. Correct the color inheritance from `fieldset` elements in IE.\n   * 3. Remove the padding so developers are not caught out when they zero out\n   *    `fieldset` elements in all browsers.\n   */\n  \n  legend {\n    box-sizing: border-box; /* 1 */\n    color: inherit; /* 2 */\n    display: table; /* 1 */\n    max-width: 100%; /* 1 */\n    padding: 0; /* 3 */\n    white-space: normal; /* 1 */\n  }\n  \n  /**\n   * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n   */\n  \n  progress {\n    vertical-align: baseline;\n  }\n  \n  /**\n   * Remove the default vertical scrollbar in IE 10+.\n   */\n  \n  textarea {\n    overflow: auto;\n  }\n  \n  /**\n   * 1. Add the correct box sizing in IE 10.\n   * 2. Remove the padding in IE 10.\n   */\n  \n  [type=\"checkbox\"],\n  [type=\"radio\"] {\n    box-sizing: border-box; /* 1 */\n    padding: 0; /* 2 */\n  }\n  \n  /**\n   * Correct the cursor style of increment and decrement buttons in Chrome.\n   */\n  \n  [type=\"number\"]::-webkit-inner-spin-button,\n  [type=\"number\"]::-webkit-outer-spin-button {\n    height: auto;\n  }\n  \n  /**\n   * 1. Correct the odd appearance in Chrome and Safari.\n   * 2. Correct the outline style in Safari.\n   */\n  \n  [type=\"search\"] {\n    -webkit-appearance: textfield; /* 1 */\n    outline-offset: -2px; /* 2 */\n  }\n  \n  /**\n   * Remove the inner padding in Chrome and Safari on macOS.\n   */\n  \n  [type=\"search\"]::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n  \n  /**\n   * 1. Correct the inability to style clickable types in iOS and Safari.\n   * 2. Change font properties to `inherit` in Safari.\n   */\n  \n  ::-webkit-file-upload-button {\n    -webkit-appearance: button; /* 1 */\n    font: inherit; /* 2 */\n  }\n  \n  /* Interactive\n     ========================================================================== */\n  \n  /*\n   * Add the correct display in Edge, IE 10+, and Firefox.\n   */\n  \n  details {\n    display: block;\n  }\n  \n  /*\n   * Add the correct display in all browsers.\n   */\n  \n  summary {\n    display: list-item;\n  }\n  \n  /* Misc\n     ========================================================================== */\n  \n  /**\n   * Add the correct display in IE 10+.\n   */\n  \n  template {\n    display: none;\n  }\n  \n  /**\n   * Add the correct display in IE 10.\n   */\n  \n  [hidden] {\n    display: none;\n  }\n","@import \"./normalize.scss\";\n\n.container {\n    max-width: 1312px;\n    margin: 0 auto;\n}\n\n@media (max-width: 1440px) {\n    .container {\n        max-width: 960px;\n    }\n}\n\n@media (max-width: 1024px) {\n    .container {\n        max-width: 750px;\n    }\n}\n\n@media (max-width: 768px) {\n    .container {\n        max-width: 90%;\n    }\n}\n\n@media (max-width: 480px) {\n    .container {\n        max-width: 95%;\n        // margin: 0;\n        // padding: 0 20px;\n    }\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-Light.eot');\n    src: local('Acrom Light'), local('Acrom-Light'),\n        url('../assets/fonts/Acrom-Light.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-Light.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-Light.woff') format('woff'),\n        url('../assets/fonts/Acrom-Light.ttf') format('truetype');\n    font-weight: 300;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-Thin.eot');\n    src: local('Acrom Thin'), local('Acrom-Thin'),\n        url('../assets/fonts/Acrom-Thin.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-Thin.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-Thin.woff') format('woff'),\n        url('../assets/fonts/Acrom-Thin.ttf') format('truetype');\n    font-weight: 100;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-Bold.eot');\n    src: local('Acrom Bold'), local('Acrom-Bold'),\n        url('../assets/fonts/Acrom-Bold.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-Bold.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-Bold.woff') format('woff'),\n        url('../assets/fonts/Acrom-Bold.ttf') format('truetype');\n    font-weight: bold;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-Regular.eot');\n    src: local('Acrom'), local('Acrom-Regular'),\n        url('../assets/fonts/Acrom-Regular.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-Regular.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-Regular.woff') format('woff'),\n        url('../assets/fonts/Acrom-Regular.ttf') format('truetype');\n    font-weight: normal;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-ExtraBold.eot');\n    src: local('Acrom ExtraBold'), local('Acrom-ExtraBold'),\n        url('../assets/fonts/Acrom-ExtraBold.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-ExtraBold.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-ExtraBold.woff') format('woff'),\n        url('../assets/fonts/Acrom-ExtraBold.ttf') format('truetype');\n    font-weight: 800;\n    font-style: normal;\n}\n\n@font-face {\n    font-family: 'Acrom';\n    src: url('../assets/fonts/Acrom-Medium.eot');\n    src: local('Acrom Medium'), local('Acrom-Medium'),\n        url('../assets/fonts/Acrom-Medium.eot?#iefix') format('embedded-opentype'),\n        url('../assets/fonts/Acrom-Medium.woff2') format('woff2'),\n        url('../assets/fonts/Acrom-Medium.woff') format('woff'),\n        url('../assets/fonts/Acrom-Medium.ttf') format('truetype');\n    font-weight: 500;\n    font-style: normal;\n}\n\nbody {\n    font-family: 'Acrom', sans-serif;\n    background-color: #2B2A29;\n}\n\nvideo {\n    object-fit: cover !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
